/*
 * File: customersParams.ts
 * Project: beaker
 * -----
 * Last Modified: 16 Mar 2022 12:16:43 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetDivisionsParams } from 'models/Division';

const initialState: GetDivisionsParams = {
  includeDeletedData: undefined,
  includeInactiveData: undefined,
  returnDeletedDivisionsOnly: undefined,
  orderByDirection: undefined,
  orderByField: undefined,
  divisionNameContains: undefined,
  businessId: undefined,
  dataAreaId: undefined,
  businessNameContains: undefined
};

export const abbyCadabbyDivisionsParams = createSlice({
  name: 'abbyCadabbyDivisionsParams',
  initialState,
  reducers: {
    setIncludeDeletedData: (state, { payload }: PayloadAction<GetDivisionsParams['includeDeletedData']>) => {
      state.includeDeletedData = payload;
    },
    setIncludeInactiveData: (state, { payload }: PayloadAction<GetDivisionsParams['includeInactiveData']>) => {
      state.includeInactiveData = payload;
    },
    setReturnDeletedDivisionsOnly: (state, { payload }: PayloadAction<GetDivisionsParams['returnDeletedDivisionsOnly']>) => {
      state.returnDeletedDivisionsOnly = payload;
    },
    setOrderByDirection: (state, { payload }: PayloadAction<GetDivisionsParams['orderByDirection']>) => {
      state.orderByDirection = payload;
    },
    setOrderByField: (state, { payload }: PayloadAction<GetDivisionsParams['orderByField']>) => {
      state.orderByField = payload;
    },
    setDivisionNameContains: (state, { payload }: PayloadAction<GetDivisionsParams['divisionNameContains']>) => {
      state.divisionNameContains = payload;
    },
    setBusinessId: (state, { payload }: PayloadAction<GetDivisionsParams['businessId']>) => {
      state.businessId = payload;
    },
    setDataAreaId: (state, { payload }: PayloadAction<GetDivisionsParams['dataAreaId']>) => {
      state.dataAreaId = payload;
    },
    setBusinessNameContains: (state, { payload }: PayloadAction<GetDivisionsParams['businessNameContains']>) => {
      state.businessNameContains = payload;
    }
  }
});

export const {
  setBusinessId,
  setBusinessNameContains,
  setDataAreaId,
  setDivisionNameContains,
  setIncludeDeletedData,
  setIncludeInactiveData,
  setOrderByDirection,
  setOrderByField,
  setReturnDeletedDivisionsOnly
} = abbyCadabbyDivisionsParams.actions;
